import { library } from "@fortawesome/fontawesome-svg-core";
import {
  fas,
  faSignOutAlt,
  faArrowLeft,
  faChevronLeft,
  faChevronRight,
  faTimes,
  faFilter,
  faCloudDownloadAlt,
  faSave,
  faPenAlt,
  faEllipsisV,
  faEllipsisH,
  faHome,
  faCaretDown,
} from "@fortawesome/free-solid-svg-icons";
import {
  far,
  faQuestionCircle,
  faTrashAlt,
  faCopy,
  faCalendarAlt,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// import {
//   faFacebookF,
//   faLinkedinIn,
//   faTwitter,
//   faInstagram
// } from "@fortawesome/free-brands-svg-icons";

library.add(
  fas,
  faArrowLeft,
  faSignOutAlt,
  faChevronLeft,
  faChevronRight,
  faFilter,
  faTimes,
  faCloudDownloadAlt,
  faSave,
  faPenAlt,
  faEllipsisV,
  faEllipsisH,
  faHome,
  faCaretDown,
  far,
  // faWindowClose,
  // faFacebookF,
  // faLinkedinIn,
  // faTwitter,
  // faInstagram,
  faQuestionCircle,
  faTrashAlt,
  faCopy,
  faCalendarAlt
  // faWindowClose
);

export { FontAwesomeIcon };
